export const EntityTypes = {};
export const Entities = {};
export const EntitiesTrueName = {};
export const EntitiesAllProps = [];
export const EntitiesDb = {}; // use it getting the match using lower case text

const configEntity = ({
    trueName,
    entity,
    route,
    redux,
    customField,
    extraFieldName,
    extraFieldTab,
    views,
    permission,
    entityDocuments,
    objectTypeId,
    icon,
    useNewApi,
    endpoint,
    countEndpoint,
    exportEntity,
    workFlow,
    duplicate,
    updateAsMassive,
    dbName,
    withoutRedirect,
    countName,
    checkDuplicates,
    withCustomizeLinkOnLists,
    addExtraFieldsButtonOnCrud,
    generalPermission,
    importExport,
    labels,
    syncWithSageEnabled,
    copilotCrudEnabled,
    crudPanelWidth,
    isMultiEnvironment,
    environmentFilterField,
}) => {
    const e = {
        trueName,
        entity,
        route,
        redux,
        customField,
        extraFieldName,
        extraFieldTab,
        views,
        permission,
        entityDocuments,
        objectTypeId,
        icon,
        useNewApi,
        endpoint,
        countEndpoint,
        exportEntity,
        workFlow,
        duplicate,
        updateAsMassive,
        dbName,
        withoutRedirect,
        countName,
        checkDuplicates,
        withCustomizeLinkOnLists,
        addExtraFieldsButtonOnCrud,
        generalPermission,
        importExport,
        labels,
        syncWithSageEnabled: syncWithSageEnabled || false,
        copilotCrudEnabled: copilotCrudEnabled || false,
        crudPanelWidth,
        isMultiEnvironment: isMultiEnvironment || false,
        environmentFilterField: environmentFilterField || null,
    };
    if (objectTypeId) EntityTypes[objectTypeId] = e;
    if (dbName) EntitiesDb[dbName.toLowerCase()] = e;
    if (entity) {
        const values = Object.keys(e).map((key) => e[key]);
        EntitiesAllProps.push({
            values,
            entity: e,
        });
        if (entity === 'salesOrders' && customField === 'tblsalesorderslines') {
            Entities.salesOrdersLines = e;
            EntitiesTrueName.salesOrdersLines = e;
        } else {
            Entities[entity] = e;
            EntitiesTrueName[trueName] = e;
        }
    }
    return e;
};

const configLabels = (labels) => {
    if (!labels) return null;
    const { singular = '', plural = '', title = '' } = labels;
    return { singular, plural, title };
};

export const COMPANIES = configEntity({
    trueName: 'accounts',
    entity: 'companies',
    route: '/companies',
    redux: 'company',
    customField: 'empresa',
    extraFieldName: 'EMPRESA',
    extraFieldTab: 'Empresas',
    views: 'ACCOUNT',
    permission: 'EMPRESA',
    entityDocuments: 'mnEmpresa',
    objectTypeId: 2,
    icon: 'entity-icon icon-accounts',
    useNewApi: null,
    endpoint: null,
    exportEntity: 'empresa',
    workFlow: 'accounts',
    duplicate: 'accounts',
    updateAsMassive: false,
    dbName: 'Empresas',
    countName: 'empresa',
    checkDuplicates: true,
    withCustomizeLinkOnLists: true,
    addExtraFieldsButtonOnCrud: true,
    generalPermission: 'empresas',
    importExport: 'accounts',
    labels: configLabels({
        singular: 'label_account',
        plural: 'label_accounts',
        title: 'title_accounts',
    }),
    syncWithSageEnabled: true,
    copilotCrudEnabled: true,
    crudPanelWidth: 650,
    isMultiEnvironment: true,
    environmentFilterField: 'environment',
});

export const CONTACTS = configEntity({
    trueName: 'contacts',
    entity: 'contacts',
    route: '/contacts',
    redux: 'contact',
    customField: 'contacto',
    extraFieldName: 'CONTACTO',
    extraFieldTab: 'Contactos',
    views: 'CONTACT',
    permission: 'CONTACTO',
    entityDocuments: 'mnContacto',
    objectTypeId: 3,
    icon: 'entity-icon icon-placeholder-user',
    useNewApi: null,
    endpoint: null,
    exportEntity: 'contacto',
    workFlow: 'contacts',
    duplicate: 'contacts',
    updateAsMassive: false,
    dbName: 'Contactos',
    countName: 'contacto',
    checkDuplicates: true,
    withCustomizeLinkOnLists: true,
    addExtraFieldsButtonOnCrud: true,
    generalPermission: 'contactos',
    importExport: 'contacts',
    labels: configLabels({
        singular: 'label_contact',
        plural: 'label_contacts',
        title: 'title_contacts',
    }),
    syncWithSageEnabled: true,
    copilotCrudEnabled: true,
    crudPanelWidth: 650,
    isMultiEnvironment: true,
    environmentFilterField: 'environment',
});

export const OPPORTUNITIES = configEntity({
    trueName: 'opportunities',
    entity: 'opportunities',
    route: '/opportunities',
    redux: 'opportunity',
    customField: 'expediente',
    extraFieldName: 'EXPEDIENTE',
    extraFieldTab: 'Expedientes',
    views: 'OPPORTUNITY',
    permission: 'EXPEDIENTE',
    entityDocuments: 'mnExpediente',
    objectTypeId: 1,
    icon: 'entity-icon icon-opportunity',
    useNewApi: null,
    endpoint: null,
    exportEntity: 'expediente',
    workFlow: 'opportunities',
    duplicate: 'opportunities',
    updateAsMassive: false,
    dbName: 'Expedientes',
    countName: 'expediente',
    checkDuplicates: false,
    withCustomizeLinkOnLists: true,
    addExtraFieldsButtonOnCrud: true,
    generalPermission: 'expedientes',
    importExport: 'opportunities',
    labels: configLabels({
        singular: 'label_opportunity_singular',
        plural: 'label_opportunities',
        title: 'title_opportunities',
    }),
    copilotCrudEnabled: true,
    crudPanelWidth: 650,
    isMultiEnvironment: true,
    environmentFilterField: 'idSucursal',
});

export const AGENDA = configEntity({
    trueName: 'calendar',
    entity: 'agenda',
    route: '/agenda',
    redux: 'agenda',
    customField: 'agenda',
    extraFieldName: 'AGENDA',
    extraFieldTab: 'tblAgenda',
    views: 'AGENDA',
    permission: 'AGENDA',
    entityDocuments: null,
    objectTypeId: 10,
    icon: null,
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: 'agenda',
    duplicate: null,
    updateAsMassive: false,
    dbName: 'tblAgenda',
    checkDuplicates: false,
    generalPermission: 'calendar',
    importExport: 'tblAgenda',
    withCustomizeLinkOnLists: true,
    addExtraFieldsButtonOnCrud: true,
    labels: configLabels({
        singular: 'label_event',
        plural: 'title_events',
        title: 'title_agenda',
    }),
    copilotCrudEnabled: true,
    crudPanelWidth: 650,
});

export const TASKS = configEntity({
    trueName: 'tasks',
    entity: 'tasks',
    route: '/agenda',
    redux: 'task',
    customField: 'agenda',
    extraFieldName: 'AGENDA',
    extraFieldTab: 'tblAgenda',
    views: '-',
    permission: 'AGENDA',
    entityDocuments: 'tasks',
    objectTypeId: 10,
    icon: null,
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: 'agenda',
    duplicate: null,
    updateAsMassive: false,
    dbName: 'tblAgenda',
    countName: 'agenda',
    checkDuplicates: false,
    generalPermission: 'calendar',
    importExport: 'tblAgenda',
    withCustomizeLinkOnLists: true,
    addExtraFieldsButtonOnCrud: true,
    labels: configLabels({
        singular: 'label_task',
        plural: 'label_tasks',
    }),
    copilotCrudEnabled: true,
    crudPanelWidth: 650,
});

// Why SALES_FORCE?
export const SALES_FORCE = configEntity({
    trueName: 'users',
    entity: 'users',
    route: '/users',
    redux: '_',
    customField: 'usuarios',
    extraFieldName: 'USER',
    extraFieldTab: '-',
    views: '',
    permission: 'USER',
    entityDocuments: 'mnUsuarios',
    objectTypeId: 5,
    icon: 'entity-icon icon-opportunity',
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: 'users',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels(),
});

export const USERS = configEntity({
    trueName: 'users',
    entity: 'users',
    route: '/users',
    redux: '_',
    customField: 'usuarios',
    extraFieldName: 'USER',
    extraFieldTab: 'tblUsuarios',
    views: '',
    permission: 'USER',
    entityDocuments: 'mnUsuarios',
    objectTypeId: 5,
    icon: 'entity-icon icon-opportunity',
    useNewApi: null,
    endpoint: 'users/v1',
    exportEntity: null,
    workFlow: 'users',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    importExport: 'users',
    labels: configLabels({
        singular: 'label_user',
        plural: 'label_users',
    }),
});

export const ACTIVITIES = configEntity({
    trueName: 'activities',
    entity: 'activities',
    route: '/activities',
    redux: 'activity',
    customField: 'gestion',
    extraFieldName: 'GESTION',
    extraFieldTab: 'Gestiones',
    views: 'ACTIVITY',
    permission: 'GESTION',
    entityDocuments: 'mnGestion',
    objectTypeId: 4,
    icon: 'entity-icon icon-annotation',
    useNewApi: null,
    endpoint: null,
    exportEntity: 'actividad',
    workFlow: 'activities',
    duplicate: null,
    updateAsMassive: false,
    dbName: 'Gestiones',
    countName: 'actividad',
    checkDuplicates: false,
    withCustomizeLinkOnLists: true,
    addExtraFieldsButtonOnCrud: true,
    generalPermission: 'gestiones',
    importExport: 'Gestiones',
    labels: configLabels({
        singular: 'label_activity',
        plural: 'page_title_activities',
        title: 'title_activities',
    }),
    copilotCrudEnabled: true,
    crudPanelWidth: 650,
});

export const DOCUMENTS = configEntity({
    trueName: 'documents',
    entity: 'documents',
    route: '/documents',
    redux: 'documents',
    customField: 'documento',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: 'DOCUMENT',
    entityDocuments: null,
    objectTypeId: null,
    icon: null,
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: 'documents',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels({
        singular: 'label_document',
        plural: 'title_documents',
        title: 'title_documents',
    }),
});

export const FOLDER_DOCUMENTS = configEntity({
    trueName: 'folder_documents',
    entity: 'folder_documents',
    route: '/folder-documents',
    redux: 'documents',
    customField: 'documento',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: 'DOCUMENTLIBRARY',
    entityDocuments: null,
    objectTypeId: null,
    icon: null,
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: 'folder_documents',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels(),
});

export const PRODUCTS = configEntity({
    trueName: 'products',
    entity: 'products',
    route: '/products',
    redux: 'products',
    customField: 'producto',
    extraFieldName: 'PRODUCTO',
    extraFieldTab: 'Productos',
    views: '-',
    permission: 'PRODUCTO',
    entityDocuments: 'mnProducto',
    objectTypeId: 6,
    icon: 'entity-icon icon-product',
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: 'products',
    duplicate: null,
    updateAsMassive: false,
    dbName: 'Productos',
    checkDuplicates: false,
    countName: 'productos',
    generalPermission: 'tarifa',
    importExport: 'Productos',
    withCustomizeLinkOnLists: true,
    addExtraFieldsButtonOnCrud: true,
    labels: configLabels({
        singular: 'label_product',
        plural: 'label_products',
        title: 'title_products',
    }),
    syncWithSageEnabled: false,
    isMultiEnvironment: true,
    environmentFilterField: 'environment',
});

export const REPORTS = configEntity({
    trueName: 'reports',
    entity: 'reports',
    route: '/reports',
    redux: 'reports',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: '-',
    entityDocuments: null,
    objectTypeId: null,
    icon: null,
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: 'reports',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels({
        singular: 'label_report',
        plural: 'label_reports',
    }),
});

export const NOTIFICATIONS = configEntity({
    trueName: 'notifications',
    entity: 'notifications',
    route: '/notifications',
    redux: 'notifications',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: '-',
    entityDocuments: null,
    objectTypeId: null,
    icon: null,
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: 'notifications',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels({
        singular: 'label_notification',
        plural: 'label_notifications',
    }),
});

export const SALESORDERS = configEntity({
    trueName: 'salesorders',
    entity: 'salesOrders',
    route: '/sales-orders',
    redux: 'salesOrders',
    customField: 'tblSalesOrders',
    extraFieldName: 'SALESORDERS',
    extraFieldTab: 'tblSalesOrders',
    views: 'SALESORDERS',
    permission: 'SALESORDERS',
    entityDocuments: 'mnSalesOrders',
    objectTypeId: 55,
    icon: 'entity-icon icon-salesorders',
    useNewApi: null,
    endpoint: null,
    exportEntity: 'salesOrders',
    workFlow: 'salesOrders',
    duplicate: null,
    updateAsMassive: false,
    dbName: 'tblSalesOrders',
    countName: 'salesorders',
    checkDuplicates: false,
    generalPermission: 'salesOrders',
    importExport: 'tblSalesOrders',
    withCustomizeLinkOnLists: true,
    addExtraFieldsButtonOnCrud: true,
    labels: configLabels({
        singular: 'label_salesorder_singular',
        plural: 'label_salesorders',
        title: 'title_salesorders',
    }),
    syncWithSageEnabled: true,
    copilotCrudEnabled: true,
    crudPanelWidth: 1200,
    isMultiEnvironment: true,
    environmentFilterField: 'environment',
});

export const SALESORDERSLINES = configEntity({
    trueName: 'salesordersLines',
    entity: 'salesOrdersLines',
    route: '/sales-orders',
    redux: 'salesOrders',
    customField: 'tblsalesorderslines',
    extraFieldName: 'SALESORDERSLINES',
    extraFieldTab: 'tblSalesOrdersLines',
    views: 'SALESORDERSLINES',
    permission: 'SALESORDERSLINES',
    entityDocuments: null,
    objectTypeId: null,
    icon: null,
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: 'salesOrders',
    duplicate: null,
    updateAsMassive: false,
    dbName: 'tblSalesOrdersLines',
    checkDuplicates: false,
    withCustomizeLinkOnLists: true,
    addExtraFieldsButtonOnCrud: true,
    labels: configLabels(),
});

export const RATES = configEntity({
    trueName: 'rates',
    entity: 'rates',
    route: '/rates',
    redux: 'rates',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: 'RATES',
    entityDocuments: null,
    objectTypeId: null,
    icon: null,
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: 'rates',
    duplicate: null,
    updateAsMassive: false,
    dbName: 'tbltarifas',
    checkDuplicates: false,
    labels: configLabels(),
});

export const KPIS = configEntity({
    trueName: 'kpis',
    entity: 'kpis',
    route: '/kpis',
    redux: 'kpis',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: 'KPIS',
    entityDocuments: null,
    objectTypeId: null,
    icon: null,
    useNewApi: true,
    endpoint: 'goals/v1',
    exportEntity: null,
    workFlow: 'kpis',
    duplicate: true,
    updateAsMassive: true,
    checkDuplicates: false,
    labels: configLabels({
        singular: 'label_goal',
        plural: 'label_goals',
        title: 'title_admin_kpis',
    }),
});

export const PHONE_CALL_LOGS = configEntity({
    trueName: 'phoneCalls',
    entity: 'phoneCallLogs',
    route: '/phone-calls',
    redux: 'phoneCallLogs',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: 'PHONE_CALL_LOGS',
    entityDocuments: 'mnPhoneCallLog',
    objectTypeId: 15,
    icon: 'entity-icon icon-call',
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: 'phoneCallLogs',
    duplicate: null,
    updateAsMassive: false,
    dbName: 'tblPhoneCallLog',
    checkDuplicates: false,
    labels: configLabels(),
});

export const BILLBOARD = configEntity({
    trueName: 'newsmanager',
    entity: 'billboard',
    route: '/news',
    redux: 'billboard',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: 'BILLBOARD',
    entityDocuments: 'mnBillboard',
    objectTypeId: 59,
    icon: 'entity-icon icon-billboard',
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: 'billboard',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels({
        singular: '',
        plural: '',
        title: 'title_billboard_billboards',
    }),
});

export const GESTION = configEntity({
    trueName: '-',
    entity: '-',
    route: '-',
    redux: '-',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: '-',
    entityDocuments: 'mnGestion',
    objectTypeId: 4,
    icon: '-',
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: '-',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels(),
});

export const MAILS = configEntity({
    trueName: 'mails',
    entity: 'mails',
    route: '-',
    redux: 'mails',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: 'MAILS',
    entityDocuments: 'mnMail',
    objectTypeId: 7,
    icon: 'entity-icon icon-email',
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: 'mails',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels(),
});

export const INTERNET_EMAIL = configEntity({
    trueName: 'internetEmails',
    entity: '-',
    route: '-',
    redux: '-',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: '-',
    entityDocuments: 'mnInternetEmail',
    objectTypeId: 23,
    icon: '-',
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: '-',
    duplicate: null,
    updateAsMassive: false,
    dbName: 'tblInternetEmail',
    checkDuplicates: false,
    labels: configLabels(),
});

/** Export-only entity for marketing campaign activities (type 15) in Activities export. */
export const MARKETING_CAMPAIGN_ACTIVITY = configEntity({
    trueName: 'marketingcampaign',
    entity: 'marketingcampaign',
    route: '-',
    redux: '-',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: '-',
    entityDocuments: null,
    objectTypeId: null,
    icon: '-',
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: '-',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels({
        singular: 'label_marketing_campaign',
        plural: 'label_marketing_campaigns',
        title: 'label_marketing_campaigns',
    }),
});

export const VIDEO_CALL_LOG = configEntity({
    trueName: '-',
    entity: '-',
    route: '-',
    redux: '-',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: '-',
    entityDocuments: 'mnGestion',
    objectTypeId: 4,
    icon: '-',
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: '-',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels(),
});

export const WHATSAPP_ACTIVITY = configEntity({
    trueName: '-',
    entity: '-',
    route: '-',
    redux: '-',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: '-',
    entityDocuments: null,
    objectTypeId: 14,
    icon: '-',
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: '-',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels(),
});

export const VIDEO_CHECK_IN = configEntity({
    trueName: '-',
    entity: '-',
    route: '-',
    redux: '-',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: '-',
    entityDocuments: 'mnGestion',
    objectTypeId: 4,
    icon: '-',
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: '-',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels(),
});

export const CUSTOM_ACTIVITY = configEntity({
    trueName: '-',
    entity: '-',
    route: '-',
    redux: '-',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: '-',
    entityDocuments: 'mnCustomActivity',
    objectTypeId: 63,
    icon: '-',
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: '-',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels(),
});

export const FORMS = configEntity({
    trueName: 'forms',
    entity: 'forms',
    route: '-',
    redux: 'forms',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: 'FORMS',
    entityDocuments: 'mnForms',
    objectTypeId: 57,
    icon: 'entity-icon icon-form',
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: 'forms',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels(),
});

export const FORMS_COMPLETED = configEntity({
    trueName: 'formsCompleted',
    entity: 'formsCompleted',
    route: '-',
    redux: 'formsCompleted',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: 'FORMS_COMPLETED',
    entityDocuments: 'mnFormsCompleted',
    objectTypeId: 58,
    icon: 'entity-icon icon-form-completed',
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: 'formsCompleted',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels(),
});

export const CAMPAIGNS = configEntity({
    trueName: 'campaigns',
    entity: 'campaigns',
    route: '/campaigns/activity',
    redux: null,
    customField: null,
    extraFieldName: 'campaigns',
    extraFieldTab: null,
    views: null,
    permission: 'CAMPAIGNS',
    entityDocuments: 'mnCampaigns',
    objectTypeId: null,
    icon: null,
    useNewApi: true,
    endpoint: 'campaigns/v1/campaign',
    exportEntity: 'campaign',
    workFlow: 'campaigns',
    duplicate: null,
    updateAsMassive: false,
    countName: 'campaigns',
    checkDuplicates: false,
    labels: configLabels({
        singular: 'label_campaign',
        plural: 'title_campaigns',
        title: 'title_campaigns',
    }),
});

export const CAMPAIGNS_MARKETING = configEntity({
    trueName: 'campaignsMarketing',
    entity: 'campaignsMarketing',
    route: '/campaigns/marketing',
    redux: null,
    customField: null,
    extraFieldName: 'campaignsMarketing',
    extraFieldTab: null,
    views: null,
    permission: null,
    entityDocuments: null,
    objectTypeId: null,
    icon: null,
    useNewApi: true,
    endpoint: 'mailing/v2/campaign',
    countEndpoint: 'mailing/v2/campaign/count',
    exportEntity: null,
    workFlow: null,
    duplicate: null,
    updateAsMassive: false,
    countName: 'campaignsMarketing',
    checkDuplicates: false,
    labels: configLabels({
        singular: 'label_marketing_campaign',
        plural: 'label_marketing_campaigns',
        title: 'label_marketing_campaigns',
    }),
});

/** Entity collections for marketing campaign recipient selection (B2 GetEntityCollections + entities-selection). */
export const ENTITY_COLLECTIONS = configEntity({
    trueName: 'entitycollections',
    entity: 'entityCollections',
    route: '/campaigns/marketing/lists',
    redux: null,
    customField: null,
    extraFieldName: 'entityCollections',
    extraFieldTab: null,
    views: null,
    permission: null,
    entityDocuments: null,
    objectTypeId: null,
    icon: null,
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: null,
    duplicate: null,
    updateAsMassive: false,
    countName: 'entitycollections',
    checkDuplicates: false,
    labels: configLabels({
        singular: 'label_marketing_campaigns_list',
        plural: 'label_marketing_campaigns_lists',
        title: 'label_marketing_campaigns_lists',
    }),
});

/** Static recipient lists under marketing; API TBD — endpoints reserved for future contract. */
export const CAMPAIGNS_LISTS = configEntity({
    trueName: 'campaignsLists',
    entity: 'campaignsLists',
    route: '/campaigns/marketing/lists',
    redux: null,
    customField: null,
    extraFieldName: 'campaignsLists',
    extraFieldTab: null,
    views: null,
    permission: null,
    entityDocuments: null,
    objectTypeId: null,
    icon: null,
    useNewApi: true,
    endpoint: 'mailing/v2/lists',
    countEndpoint: 'mailing/v2/lists/count',
    exportEntity: null,
    workFlow: null,
    duplicate: null,
    updateAsMassive: false,
    countName: 'campaignsLists',
    checkDuplicates: false,
    labels: configLabels({
        singular: 'label_marketing_campaigns_list',
        plural: 'label_marketing_campaigns_lists',
        title: 'label_marketing_campaigns_lists',
    }),
});

/** Email templates under marketing; API TBD — endpoints reserved for future contract. */
export const CAMPAIGNS_TEMPLATES = configEntity({
    trueName: 'campaignsTemplates',
    entity: 'campaignsTemplates',
    route: '/campaigns/marketing/templates',
    redux: null,
    customField: null,
    extraFieldName: 'campaignsTemplates',
    extraFieldTab: null,
    views: null,
    permission: null,
    entityDocuments: null,
    objectTypeId: null,
    icon: null,
    useNewApi: true,
    endpoint: 'mailing/v2/templates',
    countEndpoint: 'mailing/v2/templates/count',
    exportEntity: null,
    workFlow: null,
    duplicate: null,
    updateAsMassive: false,
    countName: 'campaignsTemplates',
    checkDuplicates: false,
    labels: configLabels({
        singular: 'label_email_template',
        plural: 'label_email_templates',
        title: 'label_email_templates',
    }),
});

export const TBLSALES = configEntity({
    trueName: 'sales',
    entity: 'sales',
    route: '-',
    redux: 'sales',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: 'SALES',
    entityDocuments: 'mnSales',
    objectTypeId: 61,
    icon: 'entity-icon icon-sales',
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: 'sales',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels(),
});

export const VIDEOCALLS = configEntity({
    trueName: 'videoCalls',
    entity: 'videoCalls',
    route: '-',
    redux: 'videoCalls',
    customField: 'videoCalls',
    extraFieldName: 'GESTION',
    extraFieldTab: 'Gestiones',
    views: null,
    permission: 'VIDEOCALLS',
    entityDocuments: null,
    objectTypeId: null,
    icon: null,
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: null,
    duplicate: null,
    updateAsMassive: false,
    dbName: 'VideoCalls',
    checkDuplicates: false,
    labels: configLabels(),
});

export const ANALYTICS = configEntity({
    trueName: 'analytics',
    entity: 'analytics',
    route: '/analytics',
    redux: null,
    customField: null,
    extraFieldName: null,
    extraFieldTab: null,
    views: null,
    permission: null,
    entityDocuments: null,
    objectTypeId: null,
    icon: 'analytics',
    useNewApi: false,
    endpoint: null,
    exportEntity: null,
    workFlow: null,
    duplicate: null,
    updateAsMassive: false,
    dbName: null,
    checkDuplicates: false,
    labels: configLabels({ title: 'label_metrics_and_reports' }),
});

export const ANALYTICS_REPORT = configEntity({
    trueName: 'analytics_report',
    entity: 'analytics_report',
    route: '/metrics/dashboards/view',
    redux: null,
    customField: null,
    extraFieldName: null,
    extraFieldTab: null,
    views: null,
    permission: null,
    entityDocuments: null,
    objectTypeId: null,
    icon: 'analytics',
    useNewApi: true,
    endpoint: 'analytics/v1/dashboards',
    exportEntity: null,
    workFlow: null,
    duplicate: null,
    updateAsMassive: false,
    dbName: null,
    withoutRedirect: true,
    checkDuplicates: false,
    labels: configLabels(),
});

export const ANALYTICS_WIDGET = configEntity({
    trueName: 'analytics_widget',
    entity: 'analytics_widget',
    route: '/analytics',
    redux: null,
    customField: null,
    extraFieldName: null,
    extraFieldTab: null,
    views: null,
    permission: null,
    entityDocuments: null,
    objectTypeId: null,
    icon: 'analytics',
    useNewApi: true,
    endpoint: 'analytics/v1/widgets',
    exportEntity: null,
    workFlow: null,
    duplicate: null,
    updateAsMassive: false,
    dbName: null,
    withoutRedirect: true,
    checkDuplicates: false,
    labels: configLabels(),
});

export const CONVERSATIONS = configEntity({
    trueName: 'conversations',
    entity: 'conversations',
    route: '/conversations',
    redux: 'conversations',
    customField: null,
    extraFieldName: null,
    extraFieldTab: null,
    views: null,
    permission: null,
    entityDocuments: null,
    objectTypeId: null,
    icon: null,
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: null,
    duplicate: null,
    updateAsMassive: false,
    dbName: null,
    countName: 'conversations',
    checkDuplicates: false,
    labels: configLabels(),
});

export const METRICS = configEntity({
    trueName: 'metrics',
    entity: 'metrics',
    route: '/metrics',
    redux: 'metrics',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: '-',
    entityDocuments: null,
    objectTypeId: null,
    icon: null,
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: '',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels(),
});

export const FIELDS = configEntity({
    trueName: 'fields',
    entity: 'fields',
    route: '-',
    redux: '-',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: '-',
    entityDocuments: null,
    objectTypeId: null,
    icon: '-',
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: '-',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels(),
});

export const DASHBOARD = configEntity({
    trueName: 'dashboard',
    entity: 'dashboard',
    route: '/dashboard',
    redux: '-',
    customField: '-',
    extraFieldName: '-',
    extraFieldTab: '-',
    views: '-',
    permission: '-',
    entityDocuments: null,
    objectTypeId: null,
    icon: '-',
    useNewApi: null,
    endpoint: null,
    exportEntity: null,
    workFlow: '-',
    duplicate: null,
    updateAsMassive: false,
    checkDuplicates: false,
    labels: configLabels(),
});
